import React from 'react'
import { render } from 'react-dom'

import PartialLoader from 'partials/loader'

const openLoader = ({ mensaje }) => {
  let containerDomNode = document.getElementById('loader-container')
  if (containerDomNode) {
    containerDomNode.parentNode.removeChild(containerDomNode)
  }
  let nuevoContainerDomNode = document.createElement('div')
  nuevoContainerDomNode.id = 'loader-container'
  nuevoContainerDomNode.className = 'custom-loader__wrapper open'
  document.body.appendChild(nuevoContainerDomNode)

  render(<PartialLoader texto={mensaje} />, nuevoContainerDomNode)
}

const closeLoader = () => {
  let containerDomNode = document.getElementById('loader-container')
  if (containerDomNode) {
    containerDomNode.parentNode.removeChild(containerDomNode)
  }
}

export default Object.freeze({
  openLoader,
  closeLoader
})
